module.exports = __webpack_public_path__ + "static/media/logo-grey.35159665.svg";